<script setup>

import AppLayout from "@/Layouts/AppLayout.vue";
import SecondaryButton from "@/Components/SecondaryButton.vue";
import {Link} from "@inertiajs/inertia-vue3";

defineProps({
  user: Object
});

const fullName = (user) => {
  let value = user.firstname;

  if (user.lastname) {
    value += ` ${user.lastname}`;
  }

  return value;
}
</script>

<template>
  <AppLayout title="Internal Directory">
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        <span v-text="fullName(user)"></span>
      </h2>
    </template>

    <div class="mx-auto max-w-7xl py-10 sm:px-6 lg:px-8">
      <div class="md:grid md:grid-cols-3">
        <div class="md:col-span-1">
          <Link :href="route('internal.directory.index')">
            <SecondaryButton>Back</SecondaryButton>
          </Link>
        </div>
        <div class="md:col-span-2">
          <table class="text-left text-sm font-light">
            <tbody>
            <tr class="border-b transition duration-300 ease-in-out hover:bg-neutral-200">
              <th scope="col" class="px-4 py-2">Title</th>
              <td class="px-4 py-2 break-words" v-text="user.title"></td>
            </tr>
            <tr class="border-b transition duration-300 ease-in-out hover:bg-neutral-200">
              <th scope="col" class="px-4 py-2">Address</th>
              <td class="px-4 py-2 break-words" v-text="user.address"></td>
            </tr>
            <tr class="border-b transition duration-300 ease-in-out hover:bg-neutral-200">
              <th scope="col" class="px-4 py-2">City</th>
              <td class="px-4 py-2 break-words" v-text="user.city"></td>
            </tr>
            <tr class="border-b transition duration-300 ease-in-out hover:bg-neutral-200">
              <th scope="col" class="px-4 py-2">State</th>
              <td class="px-4 py-2 break-words" v-text="user.state"></td>
            </tr>
            <tr class="border-b transition duration-300 ease-in-out hover:bg-neutral-200">
              <th scope="col" class="px-4 py-2">Zip</th>
              <td class="px-4 py-2 break-words" v-text="user.zip"></td>
            </tr>
            <tr class="border-b transition duration-300 ease-in-out hover:bg-neutral-200" v-if="user.pager">
              <th scope="col" class="px-4 py-2">Pager</th>
              <td class="px-4 py-2 break-words" v-text="user.pager"></td>
            </tr>
            <tr class="border-b transition duration-300 ease-in-out hover:bg-neutral-200" v-if="user.alphapager">
              <th scope="col" class="px-4 py-2">Alpha Pager</th>
              <td class="px-4 py-2 break-words" v-text="user.alphapager"></td>
            </tr>
            <tr class="border-b transition duration-300 ease-in-out hover:bg-neutral-200" v-if="user.cell">
              <th scope="col" class="px-4 py-2">Cell Phone</th>
              <td class="px-4 py-2 break-words" v-text="user.cell"></td>
            </tr>
            <tr class="border-b transition duration-300 ease-in-out hover:bg-neutral-200">
              <th scope="col" class="px-4 py-2">Email</th>
              <td class="px-4 py-2 break-words" v-text="user.email"></td>
            </tr>
            </tbody>
          </table>

        </div>
      </div>
    </div>
  </AppLayout>
</template>
